export default __webpack_public_path__ + "static/media/ranger_icon.fcf5b944.png";